export enum TaxonomyIndustry {
  WIND = 0,
  RAIL = 1,
}

export interface Taxonomy {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  severityDescription: SeverityDescriptionTypes;
  plantUnitDescription: string;
  plantUnitId: string;
  companyId: string;
  companyName: string;
  siteCountryCode: string;
  siteCountryDescription: string;
  siteAreaDescription: string;
  model: string;
  isEditedInWeb: boolean;
}

export type ResponseMessage = {
  Title: string;
  Status: number;
};

export type SeverityDescriptionTypes =
  | 'good'
  | 'undetermined'
  | 'suspected'
  | 'moderate'
  | 'severe';

export interface WindTaxonomy {
  taxonomyCustomer: TaxonomyCustomerAdmin;
  taxonomyCustomerUpdateTimeWeb: Date | string | null;
  taxonomySystemInfoUpdateTimeWeb: Date | string | null;
  taxonomyCustomerEditedInWeb: boolean;
  taxonomySystemInfoIsEditedInWeb: boolean;
}
export interface TaxonomyCustomerAdmin {
  plantUnitKey: string;
  sectorCode: string;
  sectorDescription: string;
  segmentCode: string;
  segmentDescription: string;
  industryCode: number;
  industryDescription: string;
  companyId: string;
  companyName: string;
  siteId: string;
  siteDescription: string;
  siteAreaDescription: string;
  siteCountryCode: string;
  siteCountryDescription: string;
  plantUnitId?: string;
  plantUnitDescription?: string;
  plantUnitCategory?: string;
  plantUnitCapacity?: number | string;
  customerStatus?: string;
  plantUnitContributionMargin?: string;
  taxonomySystemInfos: TaxonomySystemInfoAdmin[];
  sourceFlag: number;
}

export interface TaxonomySystemInfoAdmin {
  plantUnitDescription?: string;
  plantUnitKey: string;
  sectionSystemKey?: string | null;
  sectionSystemId: string;
  sectionSystemDescription: string;
  systemBrand: string;
  systemModel: string;
  sectionSystemCapacity: string;
  sectionSystemContributionMargin: string;
  systemProperty1: string;
  systemProperty2: string;
  systemSequenceCode: string;
  siteCountryDescription?: string;
  latitude: number;
  longitude: number;
  commissioningDate: Date | string;
  systemInfoStatus?: string;
  taxonomyAssetLocations: any[];
  assetKey?: string;
  position?: string;
  assetId?: string;
  assetPartKey?: string;
  competitorProductIdentification?: string;
  customerPartCode?: string;
  customerPartDescription?: string;
  installedDate?: string;
  oemPartCode?: string;
  oemPartDescription?: string;
  partId?: string;
  partManufacturer?: string;
  partName?: string;
  skfPartCode?: string;
  skfProductGroup?: string;
  isNewBrandOrModel?: number; //0 Brand or Model exist, 1 Brand or Model are new
}

export interface TaxonomySystemInfoAdminCompleted {
  plantUnitKey: string;
  sectionSystemKey?: string | null;
  sectionSystemId: string;
  sectionSystemDescription: string;
  systemBrand: string;
  systemModel: string;
  sectionSystemCapacity: string;
  sectionSystemContributionMargin: string;
  systemProperty1: string;
  systemProperty2: string;
  systemSequenceCode: string;
  latitude: number;
  longitude: number;
  commissioningDate: Date | string;
  systemInfoStatus?: string;
  plantUnitDescription?: string;
  siteCountryCode?: string;
  siteCountryDescription?: string;
  companyName?: string;
  taxonomyAssetLocations: TaxonomyAssetInfoAdmin[];
}

export interface TaxonomyAssetInfoAdmin {
  subSystem2Key: string;
  sectionSystemKey: string;
  plantUnitKey: string;
  subSystem2Id: string;
  subSystem2Description: string;
  assetKey: string;
  plantUnitDescription: string;
  sectionSystemId: string;
  assetId: string;
  assetClassDescription: string;
  taxonomiesPart: TaxonomyBearingInfoAdmin[];
  assetClaseCode: string;
  manufacturerModel: string;
  manufacturerName: string;
  manufacturerSerialNumber: string;
  costReplacement: string | null;
  purchaseCondition: string;
  equioAttributes: string;
  assetInstalledDate: Date;
  assetPartKey?: string;
}

export interface TaxonomyAssetNameBearings {
  sectionSystemKey: string;
  plantUnitKey: string;
  assetKey: string;
  assetId: string;
  taxonomiesPart: TaxonomyBearingInfoAdmin[];
  assetClaseCode: string;
  assetInstalledDate: Date;
  assetPartKey?: string;
}

export interface ModifyAsset {
  assetKey: string;
  windFarmId: string;
  turbineId: string;
  sectionSystemKey: string;
  assetId: string;
  assetClassCode: string;
  manufacturerModel: string;
  manufacturerName: string;
  manufacturerSerialNumber: string;
  costReplacement: string | null;
  purchaseCondition: string;
  equipAttributes: string;
  assetInstalledDate: Date;
  IsChangeModel: boolean;
  IsNew?: boolean;
  IsModify?: boolean;
  assetPartKey?: string[];
  plantUnitKey: string;
}

export interface TaxonomyAssetManufacturer {
  //Parece que de este solo necesitamos manufacturerName:string; manufacturerSerialNumber:string;
  assetKey: string;
  subSystem2Key: string;
  assetId: string;
  assetCategoryCode: string;
  assetCategoryDescription: string;
  assetClassCode: string;
  assetClassDescription: string;
  assetTypeCode: string;
  assetTypeDescription: string;
  assetSecuenceCode: string;
  assetSecuenceDescription: string;
  assetClassTypeCode: string;
  assetClassTypeDescription: string;
  manufacturerModel: string;
  manufacturerName: string[];
  manufacturerSerialNumber: string;
  costReplacement?: string | null;
  purchaseCondition: string;
  equipAttributes: string;
  assetInstalledDate: Date;
}

export interface TaxonomyAddAssetInfo {
  windFarmId: string;
  turbineId?: string;
  sectionSystemKey?: string;
  assetId: string;
  assetClassCode: string;
  manufacturerModel: string;
  manufacturerName: string;
  manufacturerSerialNumber: string;
  costReplacement: string | null;
  purchaseCondition: string;
  equipAttributes: string;
  assetInstalledDate?: Date | string;
  isNew: boolean;
  plantUnitKey: string;
}

export interface BearingPositions {
  positions: string[];
}

export interface TaxonomyAssetInfoAdminCompleted {
  subSystem2Key: string;
  sectionSystemKey: string;
  plantUnitKey: string;
  subSystem1Id: string;
  subSystem1Description: string;
  subSystem1SequenceCode: string;
  subSystem1ManufacturerName: string;
  subSystem1ManufacturerModel: string;
  subSystem1SerialNumber: string;
  subSystem2Id: string;
  subSystem2Description: string;
  subSystem2SequenceCode: string;
  subSystem2ManufacturerName: string;
  subSystem2ManufacturerModel: string;
  subSystem2SerialNumber: string;
  subSystem2Property1: string;
  subSystem2Property2: string;
  assetKey: string;
  plantUnitDescription: string;
  sectionSystemId: string;
  assetId: string;
  assetClassDescription: string;
  taxonomiesPart: TaxonomyBearingInfoAdmin[];
}

export interface TaxonomyBearingInfoAdmin {
  plantUnitKey?: string;
  assetId?: string;
  assetPartKey: string;
  assetKey?: string;
  position: string;
  partId: string;
  partName: string;
  functionalLocationId: string;
  functionalLocationDescription: string;
  skfProductGroup: string;
  partManufacturer: string;
  skfPartCode: string;
  competitorProductIdentification: string;
  oemPartCode: string;
  oemPartDescription: string;
  customerPartCode: string;
  customerPartDescription: string;
  installedDate: string;
  partSerialNumber: string;
  partManufacturingDate: string;
  partManufacturingSite: string;
}
export interface BearingToPost {
  AssetKey: string;
  assetPartKey: string;
  position: string;
  partId: string;
  partName: string;
  skfProductGroup: string;
  partManufacturer: string;
  skfPartCode: string;
  competitorProductIdentification: string;
  oemPartCode: string;
  oemPartDescription: string;
  customerPartCode: string;
  customerPartDescription: string;
  installedDate: Date;
  plantUnitKey: string;
}
export interface TaxonomyBearingInfoAdminCompleted {
  assetId?: string;
  assetPartKey: string;
  position: string;
  partId: string;
  partName: string;
  functionalLocationId: string;
  functionalLocationDescription: string;
  skfProductGroup: string;
  partManufacturer: string;
  skfPartCode: string;
  competitorProductIdentification: string;
  oemPartCode: string;
  oemPartDescription: string;
  customerPartCode: string;
  customerPartDescription: string;
  installedDate: string;
  partSerialNumber: string;
  partManufacturingDate: string;
  partManufacturingSite: string;
}

export interface TaxonomyCountryCustomer {
  siteCountryCode: string;
  siteCountryDescription: string;
  siteAreaDescription: string;
}

export interface TaxonomyCustomerBrand {
  systemBrand: string;
  systemModel: string;
}

export interface TaxonomyOperations {
  user: string;
  id: string;
  status: number;
  latestTime: string;
}

export interface Bearing {
  assetPartKey: string;
  position: string;
  partId: string;
  partName: string;
  functionalLocationId: string;
  functionalLocationDescription: string;
  skfProductGroup: string;
  partManufacturer: string;
  skfPartCode: string;
  competitorProductIdentification: string;
  oemPartCode: string;
  oemPartDescription: string;
  customerPartCode: string;
  customerPartDescription: string;
  installedDate?: Date;
  partSerialNumber: string;
  partManufacturingDate?: Date;
  partManufacturingSite: string;
  assetId: string;
}

export interface ITurbineManagementAssetsProps {
  taxonomy?: TaxonomySystemInfoAdmin;
  turbines?: TaxonomySystemInfoAdminCompleted[];
  windfarms?: TaxonomyCustomerAdmin[];
  assets?: TaxonomyAssetInfoAdmin;
  turbineSelected?: string | number;
  onClose: () => void;
}

export interface IassetKeyUpdate {
  assetKey?: string;
}

export interface ITurbineDeletedInfo {
  sectionSystemKey: string;
}

export interface ITaxonomyUpload {
  fileName: string;
  fileURL: string;
  loadTime: string;
  status: string;
  comments: string[];
  userEmail: string;
}

export const EXCEL_APPLICATION_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
